/**
 * T-203 (v1.8.73, Session 48, 15.10.2026, Kundin-Mail 14.10.2026 16:39): wirksame Mindestteilnehmerzahl je Online-Buchung.
 * Ab 1 Person buchbar, wenn der Termin die Mindestteilnehmerzahl erreicht hat (T-060, v1.8.15) ODER von der Verwaltung
 * manuell freigegeben ist (neu, Erik-Entscheidung Stufe B). Sonst bleibt das Minimum je Buchung die Mindestzahl des Termins
 * (nicht freigegebene Termine erscheinen im Buchungsdialog ohnehin nicht, Befund B7). Das Backend prüft dieselbe Regel
 * (Business.Buchung.Kleingruppenregel im AvailabilityService).
 */
export interface MitFreigabe {
  minCapacity: number;
  currentBookings?: number | null;
  isManuallyReleased?: boolean | null;
}

/** Ob die Mindestteilnehmerzahl des Termins schon erreicht ist (Termin bestätigt). */
export function mindestzahlErreicht(slot: MitFreigabe): boolean {
  return (slot.currentBookings ?? 0) >= slot.minCapacity;
}

/** Wirksames Minimum je Buchung: 1 auf bestätigten oder manuell freigegebenen Terminen, sonst die Mindestzahl des Termins. */
export function wirksamesMinimum(slot: MitFreigabe): number {
  if (mindestzahlErreicht(slot) || slot.isManuallyReleased === true) return 1;
  return slot.minCapacity;
}

/** Zusatz hinter "Minimum: 1" im Buchungsdialog; leer, wenn das Minimum nicht 1 ist. */
export function kleingruppenHinweis(slot: MitFreigabe): string {
  if (wirksamesMinimum(slot) !== 1) return '';
  return mindestzahlErreicht(slot)
    ? ' (Termin bestätigt, Kleingruppen und Einzelpersonen buchbar)'
    : ' (Termin freigegeben, Kleingruppen und Einzelpersonen buchbar)';
}
